import type { ChatMessageResearchStore } from './types';

/**
 * Returns true when a research store entry has any populated steps or research plans.
 * Exported so tests can import the real predicate rather than re-implementing it locally.
 */
export const messageResearchHasData = (
	research: ChatMessageResearchStore[string] | null | undefined,
): boolean =>
	!!research &&
	(Object.keys(research.steps ?? {}).length > 0 ||
		Object.keys(research.researchPlans ?? {}).length > 0);
